export const FirebaseConfig = {
	"projectId": "sendsenerandapp",
	"appId": "1:878520898236:web:88eea87c0760a3d3ecf6b9",
	"databaseURL": "https://sendsenerandapp-default-rtdb.firebaseio.com",
	"storageBucket": "sendsenerandapp.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyDTDiY-d5Kn2fv6WTfWHq6TW1_S4JzMre4",
	"authDomain": "sendsenerandapp.firebaseapp.com",
	"messagingSenderId": "878520898236",
	"measurementId": "G-QL2KE449F8"
};